import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source"];

  copy() {
    if (!navigator.clipboard) {
      console.warn("Clipboard API not supported");
      return;
    } else {
      navigator.clipboard.writeText(this.sourceTarget.id);

      this.sourceTarget.classList.add("bg-green-100");
      setTimeout(() => {
        this.sourceTarget.classList.remove("bg-green-100");
      }, 2000);
      console.log("Copied to clipboard:", this.sourceTarget.id);
    }
  }
}
